<template>
  <div class="hudongSearch">
    <div class="head">
      <div class="NewInputZu" v-if="current == 0">
        <van-search
          v-model="shiwuNameLike"
          placeholder="搜索"
          @input="shiwuLike"
          class="NewInput"
          :clearable="false"
        />
        <p @click="clearShiwuInput">取消</p>
      </div>
      <div class="NewInputZu" v-if="current == 1">
        <van-search
          v-model="jiaotongNameLike"
          placeholder="搜索"
          @input="jiaotongLike"
          class="NewInput"
          :clearable="false"
        />
        <p @click="clearJiaotongInput">取消</p>
      </div>
      <div class="navLunbo">
        <ul>
          <li
            v-for="(item, index) in NavList"
            :key="index"
            :class="{ active: index == current }"
            @click="change(index)"
          >
            <div class="p">
              {{ item }}
              <div :class="{ xiahuaxian: index == current }"></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="containerSearch">
      <Hudong2 v-if="current == 0" ref="hudong2"></Hudong2>
      <Hudong4
        v-else-if="current == 1"
        ref="hudong4"
        @clearInput="clearInput"
      ></Hudong4>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import { Swipe, SwipeItem } from "vant";
import Vue from "vue";
import { Search } from "vant";
import { DropdownMenu, DropdownItem } from "vant";
import { List } from "vant";
import { Icon } from "vant";
import Hudong2 from "../components/Hudong2";

import Hudong4 from "../components/Hudong4";
import { Dialog } from "vant";

Vue.use(Icon);

Vue.use(List);

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Swipe);
Vue.use(SwipeItem);

Vue.use(Search);
export default {
  components: {
    Hudong2,
    Hudong4,
  },
  created() {
    // doRem();
    // const _html = document.querySelector("html");
    // _html.style.fontSize = "calc(100vw / 75)";
    // console.log(document.querySelector("html"));
  },
  mounted() {
    document.querySelector("body").setAttribute("style", "overflow:hidden;");
  },
  destroyed() {
    document.querySelector("body").setAttribute("style", "overflow:auto;");
  },
  data() {
    return {
      isNewInputShow: true,
      shiwuNameLike: "",
      NavList: ["失物招领", "交通出行"],
      current: 0,
      isNavShow: false,
      jiaotongNameLike: "",
    };
  },
  methods: {
    change(index) {
      this.current = index;
      this.shiwuNameLike = "";
      this.jiaotongNameLike = "";
    },
    shiwuLike() {
      this.isNavShow = true;
      this.$refs.hudong2.hudong2Like(this.shiwuNameLike);
    },
    jiaotongLike() {
      this.isNavShow = true;
      this.$refs.hudong4.hudong4Like(this.jiaotongNameLike);
    },
    clearInput() {
      this.jiaotongNameLike = "";
    },

    clearShiwuInput() {
      this.shiwuNameLike = "";
      this.isNavShow = false;
      this.$refs.hudong2.hudong2Like(this.shiwuNameLike);
      this.$router.push("/");
    },
    clearJiaotongInput() {
      this.jiaotongNameLike = "";
      this.isNavShow = false;
      this.$refs.hudong4.hudong4Like(this.jiaotongNameLike);
    },
  },
};
</script>

<style lang="scss" scoped>
.head {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 1000;
  background-color: #fff;
  .title {
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid #eaeaea;
    font-size: 1.875rem;
    color: #19212a;
    background-color: #fff;

    .zuojian {
      position: absolute;
      top: 0;
      left: 2.125rem;
    }
  }
  .NewInputZu {
    display: flex;
    align-items: center;
    padding-top: 1.875rem;
    padding-left: 2.125rem;
    p {
      font-size: 1.75rem;
      color: #338989;
      margin-left: 1.75rem;
    }
  }
  .navLunbo {
    width: 100%;
    height: auto;
    padding: 0 2rem;
    margin-top: 2.25rem;
    background-color: #ffffff;
    font-size: 1.75rem;
    color: #19212a;
    display: flex;
    justify-content: center;
    align-items: center;

    ul {
      display: flex;
      white-space: nowrap;
      overflow: auto;

      li {
        margin-left: 2.5rem;
        text-align: center;
        letter-spacing: 1px;
        line-height: 3.5rem;
        margin-right: 2.5rem;
      }
    }

    .xiahuaxian {
      height: 0.5rem;
      background: #338989;
      border-radius: 0.5rem;
      margin-top: 0.875rem;
    }

    .active {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #338989;
      font-size: 2.125rem;
      font-weight: bold;
    }
  }
}
.containerSearch {
  margin-top: 13.75rem;
}
</style>
<style lang="scss" scoped>
.NewInputZu ::v-deep .NewInput {
  width: 36.625rem;
  height: 5rem;
  background: #f9f9f9;
  padding: 0;
  border-radius: 2.5rem;
  .van-search__content {
    border-radius: 2.5rem;
    padding-left: 2.625rem;
    background: #f9f9f9;

    .van-cell {
      padding: 0;

      .van-cell__value--alone .van-field__body .van-field__control {
        font-size: 1.75rem;
        color: #878787;
        margin-left: 0.625rem;
      }

      .van-field__left-icon .van-icon {
        font-size: 2.5rem;
        color: #878787;
      }
    }
  }
}
</style>